import React from 'react';
import fetch from '../fetch';
import utils from '../../utils';
import {Modal} from 'antd'

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    // {type: 'selection'},
    {key:'$index', label: '序号' , width : 80},
    {key:'employeeOrgName', label: '授课教师学院',width : 120},
    {key:'employeeName', label: '授课教师' ,width : 120},
    {key:'studentOrgName', label: '学生学院' ,width : 120},
    {key:'className', label: '学生班级' ,width : 120},
    {key:'courseName' , label : '课程名称' , width : 120},
    {key:'classRoom', label: '教室' ,width : 120},
    {key: 'listenerName' , label : '听课人' , width : 120},
    {key: 'createrName' , label : '录入人' , width : 120},
    {key:'listenTime', label: '听课时间' ,width : 120},
    {key:'finalEvaluation', label: '课程总体评价' ,width : 120},
    {key:'termName', label: '学期' ,width : 120},
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('leader/listen/list?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const update = (data , id) => {
    return fetch.post('leader/listen/update/'+id , data);
}

const querySearchById = (id) => {
    return fetch.get('leader/listen/get/'+id)
    .then(respons => {
        return respons.payload.data
    });
}


const remove = (ids) => {
    return fetch.post('leader/listen/remove/', ids)
    .then(response => {
        return response;
    });
}

const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{'删除成功'}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                DataGrid.selections = [];
                                DataGrid.refresh();
                            },
                        });
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

export default {
    columns,
    onSelect,
    setRefresh,
    getSelection,
    querySearch ,
    update ,
    querySearchById ,
    batchRemove
}